export default __webpack_public_path__ + "static/media/partners5.198bc4b4.png";